// Import external
import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[synField]'
})
export class FieldDirective implements OnInit {

    constructor(private ele: ElementRef) {
    }

    ngOnInit() {
        this.ele.nativeElement.className = this.ele.nativeElement.className +
            ' syn-field';
    }
}
